import { TYPES } from 'action-types/booking'
import * as validateMessage from 'constants/validationMessages'

interface IAction {
    readonly type: string;
    readonly errors: any[];
    readonly delete: any;
    readonly update: string;
    readonly distributionData: any;
    readonly validateJobStatus: any;
    readonly editChargeItemStatus: any;
    readonly chargeItemData: any;
    readonly chargeItemDeleteStatus: any;
}
export interface INewCostRevenueState {
    readonly isFetchDataLoading: boolean;
    readonly isFetchDataError: boolean;
    readonly pendingError: string;
    readonly delete: any;
    readonly update: string;
    readonly distributionData: any;
    readonly validateJobStatus: any;
    readonly editChargeItemStatus: any;
    readonly chargeItemData: any;
    readonly chargeItemDeleteStatus: any;
}
export const defaultState: INewCostRevenueState = {
  isFetchDataLoading: false,
  isFetchDataError: false,
  pendingError: '',
  update: '',
  distributionData: {},
  delete: {},
  validateJobStatus: false,
  editChargeItemStatus: {
    validateStatus: true,
    message: ''
  },
  chargeItemData: [],
  chargeItemDeleteStatus: null
}

const check = (error:any) => {
  if(error && !Array.isArray(error) ||
    (error && Array.isArray(error) && error.length> 0)){
    return error
  }
  return ''
}
export const reducer = (state: INewCostRevenueState = defaultState, action: IAction): INewCostRevenueState => {
  switch (action.type) {
  case TYPES.FETCH_DISTRIBUTION_DATA.REJECTED:
    return {
      ...state,
      isFetchDataLoading: false,
      isFetchDataError: true,
      pendingError: check(action.errors)?action.errors.toString():validateMessage.CostAndRevenue.Error_Retrieve_charges
    }
  case TYPES.FETCH_DISTRIBUTION_DATA.PENDING:
    return {
      ...state,
      isFetchDataLoading: true,
      isFetchDataError: false,
      pendingError: ''
    }
  case TYPES.FETCH_DISTRIBUTION_DATA.FULFILLED:
    return {
      ...state,
      isFetchDataLoading: false,
      isFetchDataError: false,
      pendingError: '',
      distributionData: action.distributionData
    }
    case TYPES.VALIDATE_JOB_STATUS.REJECTED:
      return {
        ...state,
        isFetchDataLoading: false,
        isFetchDataError: true,
        pendingError: check(action.errors)?action.errors.toString():validateMessage.CostAndRevenue.Error_Retrieve_charges
      }
    case TYPES.VALIDATE_JOB_STATUS.PENDING:
      return {
        ...state,
        isFetchDataLoading: true,
        isFetchDataError: false,
        pendingError: ''
      }
    case TYPES.VALIDATE_JOB_STATUS.FULFILLED:
      return {
        ...state,
        isFetchDataLoading: false,
        isFetchDataError: false,
        pendingError: '',
        validateJobStatus: action.validateJobStatus
      }

    case TYPES.VALIDATE_CBL_EDIT_STATUS.REJECTED:
      return {
        ...state,
        isFetchDataLoading: false,
        isFetchDataError: true,
        pendingError: check(action.errors)?action.errors.toString():validateMessage.CostAndRevenue.Error_Retrieve_charges
      }
    case TYPES.VALIDATE_CBL_EDIT_STATUS.PENDING:
      return {
        ...state,
        isFetchDataLoading: true,
        isFetchDataError: false,
        pendingError: '',
        editChargeItemStatus: defaultState.editChargeItemStatus
      }
    case TYPES.VALIDATE_CBL_EDIT_STATUS.FULFILLED:
      return {
        ...state,
        isFetchDataLoading: false,
        isFetchDataError: false,
        pendingError: '',
        editChargeItemStatus: action.editChargeItemStatus
      }
      case TYPES.GET_CHARGE_ITEM_DETAILS_EDIT.REJECTED:
        return {
          ...state,
          isFetchDataLoading: false,
          isFetchDataError: true,
          pendingError: check(action.errors)?action.errors.toString():validateMessage.CostAndRevenue.Error_Retrieve_charges
        }
      case TYPES.GET_CHARGE_ITEM_DETAILS_EDIT.PENDING:
        return {
          ...state,
          isFetchDataLoading: true,
          isFetchDataError: false,
          pendingError: '',
          chargeItemData: defaultState.chargeItemData
        }
      case TYPES.GET_CHARGE_ITEM_DETAILS_EDIT.FULFILLED:
        return {
          ...state,
          isFetchDataLoading: false,
          isFetchDataError: false,
          pendingError: '',
          chargeItemData: action.chargeItemData
        }

        case TYPES.DELETE_CHARGE_ITEMS_CBL.REJECTED:
          return {
            ...state,
            isFetchDataLoading: false,
            isFetchDataError: true,
            pendingError: check(action.errors)?action.errors.toString():validateMessage.CostAndRevenue.Error_Retrieve_charges
          }
        case TYPES.DELETE_CHARGE_ITEMS_CBL.PENDING:
          return {
            ...state,
            isFetchDataLoading: true,
            isFetchDataError: false,
            pendingError: '',
            chargeItemDeleteStatus: defaultState.chargeItemDeleteStatus
          }
        case TYPES.DELETE_CHARGE_ITEMS_CBL.FULFILLED:
          return {
            ...state,
            isFetchDataLoading: false,
            isFetchDataError: false,
            pendingError: '',
            chargeItemDeleteStatus: action.chargeItemDeleteStatus
          }
  default:
    return state
  }
}
